const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/eCheckin/components/fields/metakat/CountryField.tsx';
import * as React from 'react';
import { forwardRef } from 'react';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import { useIntl } from 'react-intl';
import { CIS4mMetaKatDropDown } from '@cistec/common_web/modules/CIS4m/components/CIS4mMetaKatDropDown';
import { MessageDescriptor } from '@formatjs/intl';
import { useCIS4FormMetaKatData } from 'App/store/cis4m';

interface Props {
    label: string | MessageDescriptor;
    path: string;
    hidden?: boolean;
    required?: boolean;
    readonly?: boolean;
}

export const CountryField = forwardRef((props: Props, ref: any) => {
    const { formatMessage, locale } = useIntl();

    const dropdownRef = useCIS4m(ref);

    const label = typeof props.label === 'string' ? props.label : formatMessage(props.label);
    const hidden = props.hidden ?? false;
    const required = props.required ?? false;
    const readonly = props.readonly ?? false;

    const sort = (metaKatItem1: any, metaKatItem2: any) => {
        return metaKatItem1.NAME.localeCompare(metaKatItem2.NAME);
    };

    return (
        <CIS4mMetaKatDropDown
            ref={dropdownRef}
            label={label}
            path={props.path}
            pcode={'71221995-e5b8-4b70-9b2f-d3400f9105d3'}
            valuePath="FKEY"
            labelPath={`CONTENT.Lang.${locale}`}
            sort={sort}
            favorites={['CH', 'DE', 'AT', 'LI', 'FR', 'IT']}
            hidden={hidden}
            required={required}
            readonly={readonly}
            dataHook={useCIS4FormMetaKatData}
        />
    );
});

CountryField.displayName = 'CountryField';
